import api from "api";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { BulkUpdateReferralsParams } from "./types";

const useBulkUpdateReferrals = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ ids, fields }: BulkUpdateReferralsParams) =>
      api.call("/uk/referral_tracking/bulk_update", {
        method: "PATCH",
        data: { ids, ...fields },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.ukReferralTracking());
      },
    }
  );
};

export default useBulkUpdateReferrals;
